<template>
  <div class="give-instruction">
    <Header>
      <!-- 授课中的展示提示 -->
      <span slot="end-tip" class="end-tip" v-if="giveLessonState === 1 && showEndTip">
        <a-icon type="exclamation-circle" class="exclamation-circle" />
        3小时后，系统会自动结束授课，再次推送视频可继续授课
        <a-icon type="close" class="close" @click="showEndTip = false" />
      </span>
      <!-- giveLessonState 授课状态：0结束授课，1授课中 -->
      <a-button type="danger" :disabled="giveLessonState === 0 || giveLessonState === -1" slot="end-btn" @click="endCourse">
        结束授课
      </a-button>
      <!-- 期中，期末讲次，没有【解锁关卡】按钮： lessonTag 1期中，2期末 -->
      <div slot="undo-btn" v-if="![1, 2].includes(Number($route.query.lessonTag))" class="undo-btn">
        <a-button class="ant-btn-secondary" :disabled="customsPassState === 1" @click="unLock">
          {{ customsPassState === 0 ? "解锁关卡" : "已解锁关卡" }}
        </a-button>

        <a-icon class="tip-icon" type="exclamation-circle" />
        <span class="describe">包含：课本例练，双色笔记，日积月累，融会贯通</span>
      </div>
    </Header>
    <div class="content">
      <div class="course-info-wrap">
        <div class="course-info">
          <!-- 课件 -->
          <div class="course-ware">
            <LessonCourseware :class-type-id="this.$route.query.classTypeId" :lesson-id="this.$route.query.lessonId" />
          </div>
          <div class="progress">
            <Footer ref="Footer" :give-lesson-state="giveLessonState" />
          </div>
        </div>
      </div>
      <div class="video-list">
        <VideoList @checkedList="getCheckedList" :list="videoList">
          <template v-if="!isLoading">
            <VideoScale v-if="isPolyv" slot="videoScale" ref="videoScale" />
            <AliVideoScale v-else slot="videoScale" ref="videoScale" />
          </template>
          <!-- palyState: 0, // 播放状态：0继续（播放中），1已暂停 -->
          <a-button
            v-if="palyState === 0"
            slot="toggle-btn"
            class="ant-btn-danger-ghost"
            :disabled="pauseDisabled"
            @click="pauseCourse"
          >
            一键暂停
          </a-button>

          <a-tooltip
            slot="toggle-btn"
            v-model="showStudyTip"
            placement="top"
            title="已暂停"
            v-else
          >
            <a-button @click="continueStudy" class="ant-btn-success-ghost">
              继续学习
            </a-button>
          </a-tooltip>

          <a-button type="primary" slot="push-btn" @click="pushIpad" :disabled="checkVideoList.length === 0">
            推送至学习机
          </a-button>
        </VideoList>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './components/header.vue'
import Footer from './components/footer.vue'
import VideoList from './components/videos.vue'
import LessonCourseware from '@/components/Courseware/LessonCourseware.vue'
import { message } from 'ant-design-vue'
import AliVideoScale from '@/components/VideoPlayer/videoScale.vue'
import VideoScale from '@/components/PolyvPlayer/VideoScale.vue'

export default {
  components: {
    Header,
    Footer,
    VideoList,
    VideoScale,
    AliVideoScale,
    LessonCourseware
  },

  data() {
    return {
      modalConfirmLoading: false,
      pauseDisabled: true,
      showEndTip: true,
      videoList: [],
      checkVideoList: [],
      palyState: 0, // 播放状态：0继续，1已暂停
      customsPassState: 0, // 四关关卡解锁状态：0未解锁，1已解锁
      giveLessonState: 0, // 授课状态：0结束授课，1授课中
      coursewareVersion: null, // 片段版本
      showStudyTip: true,
      isPolyv: true, // 是否是保利威视
      isLoading: true // 视频加载中
    }
  },

  async created() {
    const res = await this.getCourseWareInfo()
    this.isPolyv = res.playerType === 1
    this.isLoading = false
    // 视频列表
    this.videoList = this.isPolyv ? res.coursewareFragments : res.videoPartScriptJs
    this.coursewareVersion = res.coursewareVersion
    const fragmentList = this.isPolyv ? res.scriptJson : res.videoFragmentList
    this.$nextTick(() => {
      if (this.isPolyv) {
        this.$refs.videoScale.playerInit({ scriptJson: fragmentList, videoUrl: res.path })
      } else {
        this.playerInit(fragmentList, this.videoList)
      }
    })
  },

  methods: {
    playerInit(fragmentList, videoList) {
      this.$refs.videoScale.playerInit({
        fragmentList,
        videoList
      })
    },

    async getCourseWareInfo(cbArr) {
      const { id, xkhTeacherCourseId, classTypeId, lessonId, aiLessonId } = this.$route.query
      const res = await this.$service.giveInstruction.courseWareInfo({
        id: Number(id),
        groupId: Number(xkhTeacherCourseId),
        classTypeId: Number(classTypeId),
        lessonId: Number(lessonId),
        aiLessonId: Number(aiLessonId)
      })
      this.palyState = res.palyState // 播放状态：0继续，1已暂停
      this.customsPassState = res.customsPassState // 四关关卡解锁状态：0未解锁，1已解锁
      this.giveLessonState = res.giveLessonState // 授课状态：0结束授课，1授课中
      this.pauseDisabled = this.giveLessonState === 0 || this.giveLessonState === -1 // 结束授课后一键暂停按钮禁用
      if (cbArr && cbArr.length) {
        cbArr.forEach(cb => cb())
      }
      return res
    },

    pushIpad() {
      this.$confirm({
        content: () => <p>确认推送至学习机吗？</p>,
        confirmLoading: this.modalConfirmLoading,
        centered: true,
        onOk: () => this.handlerPushIpad(),
        cancelText: '取消'
      })
    },

    handlerPushIpad() {
      this.modalConfirmLoading = true
      return new Promise((resolve, reject) => {
        const { id, xkhTeacherCourseId, classTypeId, lessonId, aiLessonId } = this.$route.query
        this.$service.giveInstruction
          .lessonPush({
            coursewareChoose: this.checkVideoList,
            xkhTeacherCourseId: Number(xkhTeacherCourseId),
            classTypeId: Number(classTypeId),
            lessonId: Number(lessonId),
            aiLessonId: Number(aiLessonId),
            coursewareVersion: Number(this.coursewareVersion),
            xkhTeacherLessonId: Number(id)
          })
          .then(res => {
            message.success('推送成功')
            // 推送成功刷新按钮状态
            this.getCourseWareInfo([this.$refs.Footer.reload])
            resolve()
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            this.modalConfirmLoading = false
          })
      })
    },

    unLock() {
      this.$confirm({
        content: () => (
          <div>
            <p>确认解锁关卡吗？</p>
          </div>
        ),
        confirmLoading: this.modalConfirmLoading,
        centered: true,
        onOk: () => this.handUnLock(),
        cancelText: '取消'
      })
    },

    handUnLock() {
      this.modalConfirmLoading = true
      return new Promise((resolve, reject) => {
        const { id } = this.$route.query
        this.$service.giveInstruction
          .courseWareUnlock({
            id: Number(id),
            unlockType: 2 // 解锁类型：1课前学，2四关关卡
          })
          .then(res => {
            message.success('解锁成功')
            // 解锁成功改变按钮状态
            this.customsPassState = 1
            resolve()
          })
          .catch(err => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject(err)
          })
          .finally(() => {
            this.modalConfirmLoading = false
          })
      })
    },

    handlerEnd() {
      const { id } = this.$route.query
      this.modalConfirmLoading = true
      return new Promise((resolve, reject) => {
        this.$service.giveInstruction
          .courseWareStartEnd({
            id,
            status: 0 // 0结束，1开始
          })
          .then(res => {
            this.modalConfirmLoading = false
            // 结束授课成功后刷新页面数据，预期是授课页内功能按钮全部置灰
            this.getCourseWareInfo()
            message.success('结束成功')
            // 结束授课成功后，停止学习进度轮询，并清空学习进度
            this.$refs.Footer.clearListAndLoop()
            resolve()
          })
          .catch(err => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject(err)
          })
          .finally(() => {
            this.modalConfirmLoading = false
          })
      })
    },

    endCourse() {
      this.$confirm({
        content: () => (
          <div>
            <p>确认结束授课吗？</p>
            <p>结束授课后，所有学生将结束本讲学习。</p>
          </div>
        ),
        confirmLoading: this.modalConfirmLoading,
        centered: true,
        // 展示不下时，需要加滚动条
        onOk: () => this.handlerEnd(),
        cancelText: '取消'
      })
    },

    // 一键暂停
    pauseCourse() {
      this.$confirm({
        content: () => <p>您确认暂停学习该讲次吗？</p>,
        confirmLoading: this.modalConfirmLoading,
        centered: true,
        onOk: this.handlerPauseCourse,
        cancelText: '取消'
      })
    },

    handlerPauseCourse() {
      this.modalConfirmLoading = true
      return new Promise((resolve, reject) => {
        console.log('this.modalConfirmLoading', this.modalConfirmLoading)
        const { id } = this.$route.query
        this.$service.giveInstruction
          .courseWarePlayPause({
            id,
            status: 1 // 0开始，1暂停
          })
          .then(res => {
            // 暂停后刷新页面数据
            this.getCourseWareInfo()
            resolve()
          })
          .catch(err => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject(err)
          })
          .finally(() => {
            this.modalConfirmLoading = false
          })
      })
    },

    // 继续学习
    continueStudy() {
      this.$confirm({
        content: () => <p>确认继续学习该讲次吗？</p>,
        confirmLoading: this.modalConfirmLoading,
        centered: true,
        onOk: this.handlerContinueStudy,
        cancelText: '取消'
      })
    },

    handlerContinueStudy() {
      this.modalConfirmLoading = true
      return new Promise((resolve, reject) => {
        const { id } = this.$route.query
        this.$service.giveInstruction
          .courseWarePlayPause({
            id,
            status: 0 // 0开始，1暂停
          })
          .then(res => {
            // 继续学习后刷新页面信息
            this.getCourseWareInfo()
            resolve()
          })
          .catch(err => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject(err)
          })
      })
    },

    getCheckedList(list) {
      this.checkVideoList = list
    }
  }
}
</script>

<style scoped lang="less">
.give-instruction {
  width: 100vw;
  height: 100vh;
  background: #fff;
  .undo-btn {
    .tip-icon {
      font-size: 12px;
      margin-left: 8px;
      margin-right: 4px;
    }
    .describe {
      font-family: "Microsoft YaHei UI";
      font-style: normal;
      font-size: 12px;
      line-height: 14px;
      vertical-align: middle;
      letter-spacing: 0.04em;
      display: inline-block;
      min-width: 30px;
      max-width: 276px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .end-tip {
    font-family: "Microsoft YaHei UI";
    padding: 12px 16px;
    background: #fff8e5;
    font-size: 12px;
    letter-spacing: 0.04em;
    color: #505873;
    border-radius: 6px;
    margin-right: 23px;
    .exclamation-circle {
      color: #ff8800;
    }
    .close {
      color: #98a2b2;
      cursor: pointer;
      font-size: 14px;
    }
  }
  .content {
    height: calc(100vh - 52px);
    width: 100vw;
    display: flex;
    .video-list {
      width: 288px;
      height: 100%;
      overflow: hidden;
    }
    .course-info-wrap {
      width: calc(100vw - 288px);
      overflow-y: overlay;
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        width: 6px;
        height: 6px;
        opacity: 0.8;
        border-radius: 3px;
        background: #c7c7c7;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-button {
        background: #fff;
      }
      &::-webkit-scrollbar-corner {
        background: #fff;
      }
      .course-info {
        width: 100%;
        height: 100%;
        .course-ware {
          height: calc(100% - 146px);
        }
        .progress {
          height: auto;
        }
      }
    }
  }
}
</style>
